import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'selectbar'
})
export class SelectbarPipe implements PipeTransform {

  transform(tag: string, bar: string, lang: string=''): string {
    let str: string = '';
    var larr = tag.split("--");
    //console.log(larr);
    if((lang == 'ar' || lang === 'undefined') && larr[1]!== '') {
      var tagArray = larr[1].split("|");
    } else {
      var tagArray = tag.split("|");
    }

    //console.log(lang);
    if(bar==="a")
    {
      str = tagArray[0].replace("|a", "").replace("/", "").replace("$", "");
      // .replace(".", "")
    } else {
      for(let i=1; i<tagArray.length;i++)
      {
        if(tagArray[i].substring(0, 1) === bar)
        {
          str = tagArray[i].substring(1, tagArray[i].length);
        }
      }
    }

    return str.replace("--", "");
  }

}
